import React, { useState } from "react";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import withPermission from "../../core/common/autorisations/withPermission";
// import { EditLinkRowProps } from "./allParent";

// composant pour modifier une relation (link)
export interface EditLinkRowProps {
  parent: any;
  allLinks: any[];
  onSave: (parentId: string, newLinkId: string) => void;
  onCancel: () => void;
}

const EditLinkRow: React.FC<EditLinkRowProps> = ({
  parent,
  allLinks,
  onSave,
  onCancel,
}) => {
  const [selectedLinkId, setSelectedLinkId] = useState(parent.link.id);

  return (
    <div className="w-100 mb-3">
      <label
        htmlFor={`link-select-${parent.id}`}
        className="form-label fw-medium"
      >
        🔗 Modifier le lien
      </label>
      <div className="d-flex align-items-center gap-2">
        <select
          id={`link-select-${parent.id}`}
          className="form-select"
          value={selectedLinkId}
          onChange={(e) => setSelectedLinkId(e.target.value)}
        >
          {allLinks.map((link) => (
            <option
              key={link.id}
              value={link.id}
              selected={link.id === selectedLinkId}
            >
              {link.type}
            </option>
          ))}
        </select>
        <button
          className="btn btn-primary"
          onClick={() => onSave(parent.studentParentId, selectedLinkId)}
        >
          Enregistrer
        </button>
        <button className="btn btn-outline-danger" onClick={onCancel}>
          Annuler
        </button>
      </div>
    </div>
  );
};

export default withPermission(
  EditLinkRow,
  [buildPermission(Resource.STUDENT, Action.UPDATE)],
  "masquer",
);
